import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import * as mixins from 'view/styles/mixins'

export const ScreenWrapper = styled.div<{ hideRightMargin?: boolean }>`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-width: 0;
  margin-right: ${props => (props.hideRightMargin ? '0' : '9px')};
  background-color: ${constants.CORE_PRIMARY_1};
`

export const SidePanel = styled.div`
  background-color: white;
  flex: 0 0 425px;
  overflow: hidden;
  margin: 3px 3px 3px 6px;
  ${mixins.panelTransition};
  &:empty {
    margin: 0;
    flex: 0 0 0;
  }
  border-radius: 5px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
`

export const CenterPanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: stretch;
  overflow: auto;
`
